// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"db6128ad","455":"fbf067e3","644":"9c3fc89d","909":"9793da47"}[chunkId] + ".chunk.js";
};